<template>
  <a 
    class="btn btn-icon btn-hover btn-circle" 
    href="javascript:;" 
    :uk-tooltip="resolvedTooltipText"
    @click="handleDownload" 
    :class="{ 'disabled': isDownloading }" 
    :style="{ opacity: isDownloading ? 0.6 : 1 }"
  >
    <i v-if="!isDownloading" class="fa-file-excel fa"></i>
    <i v-else class="fa-spinner fa-spin fa"></i>
  </a>
</template>

<script>
export default {
  name: "ExcelDownloadButton",
  props: {
    tooltipText: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'default', // 'small', 'default', 'large'
      validator: value => ['small', 'default', 'large'].includes(value)
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDownloading() {
      return this.loading;
    },
    resolvedTooltipText() {
      return this.tooltipText || this.$t('general.export_to_excel');
    }
  },
  methods: {
    handleDownload() {
      if (this.isDownloading) {
        return;
      }
      
      this.$emit('download');
    }
  }
};
</script>

<style scoped>
.btn.disabled {
  pointer-events: none;
  cursor: not-allowed;
}

.btn.disabled:hover {
  background-color: inherit;
  border-color: inherit;
}

/* Buton boyutları */
.btn.btn-sm .fa {
  font-size: 0.875rem;
}

.btn.btn-lg .fa {
  font-size: 1.25rem;
}

/* Spinner animasyonu */
.fa-spinner.fa-spin {
  animation: fa-spin 1s infinite linear;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
